<template>
  <div class="shop" :class="$store.state.theme">
    <MainBackButton />

    <div class="field has-addons is-pulled-right navigation" style="margin-bottom:4px" :key="z">
      <!-- <div class="control" v-if="selected">
        <div class="button is-info is-rounded" @click="selected = null">{{ translateSelected }}</div>
      </div>
      <div class="control" v-else>
        <div class="button is-primary is-rounded is-static">{{ $t("select") }}</div>
      </div>-->
      <div class="control">
        <span class="button is-rounded is-info is-outlined side-btn" @click="toggleSearch">
          <span class="icon">
            <i v-if="searching" class="fa fa-times-circle" />
            <i v-else class="fa fa-search" />
          </span>
        </span>
      </div>
      <div class="control is-expanded" v-if="searching">
        <input
          class="input is-rounded is-primary searchbox"
          @keyup="search($event)"
          type="text"
          :placeholder="searchPlaceholder"
        />
      </div>
      <div class="control" v-if="showShopsButton">
        <div
          class="button is-info is-rounded middle-btn"
          :class="{'is-outlined': selected !== 'shops'}"
          @click="select('shops')"
        >
          <i class="fa fa-store-alt" style="padding-right:4px" />
          {{ $t("shop.shops") }}
        </div>
      </div>
      <div class="control" v-if="showServicesButton">
        <div
          class="button is-info is-rounded middle-btn"
          :class="{'is-outlined': selected !== 'services'}"
          @click="select('services')"
        >
          <i class="fa fa-tools" style="padding-right:4px" />
          {{ $t("shop.services") }}
        </div>
      </div>
      <div class="control" v-if="selected">
        <span class="button is-rounded is-info is-outlined side-btn" @click="toggleView">
          <span class="icon">
            <i v-if="listView" class="fa fa-globe" />
            <i v-else class="fa fa-list" />
          </span>
        </span>
      </div>
    </div>

    <!-- <div class="field has-addons is-pulled-right navigation" style="margin-bottom:4px">
      <div class="control" v-if="selected">
        <div class="button is-info is-rounded" @click="selected = null">{{ translateSelected }}</div>
      </div>
      <div class="control" v-else>
        <div class="button is-primary is-rounded is-static">{{ $t("select") }}</div>
      </div>
      <div class="control" v-if="!selected">
        <div class="button is-info is-rounded is-outlined" @click="select('shops')">
          <i class="fa fa-store-alt" />
          &nbsp;{{ $t("shop.shops") }}
        </div>
      </div>
      <div class="control" v-if="!selected">
        <div class="button is-info is-rounded is-outlined" @click="select('services')">
          <i class="fa fa-tools" />
          &nbsp;
          {{ $t("shop.services") }}
        </div>
      </div>
      <div class="control is-expanded" v-if="selected">
        <input
          class="input is-rounded is-info"
          @keyup="search($event)"
          type="text"
          :placeholder="searchPlaceholder"
        />
      </div>
      <div class="control" v-if="selected">
        <span class="button is-rounded is-info is-outlined map-btn" @click="toggleView">
          <span class="icon">
            <i v-if="listView" class="fa fa-globe" />
            <i v-else class="fa fa-list" />
          </span>
        </span>
      </div>
    </div>-->

    <ShopLive />

    <!-- Filters: Alphabet, Category, Distance, Favorite, New -->
    <div style="width:100%; margin-top:5px; margin-bottom:5px">
      <span class="buttons is-centered single-line" style="width:100vw">
        <span
          class="button is-rounded is-link is-small"
          :class="{'is-outlined': sortedBy !== 'alphabet'}"
          @click="sortBy('alphabet')"
        >
          <i class="fa fa-sort-alpha-down" />
          &nbsp;{{ $t("shop.alphabet") }}
        </span>
        <span
          class="button is-rounded is-link is-small"
          :class="{'is-outlined': sortedBy !== 'category'}"
          @click="sortBy('category')"
        >
          <i class="fa fa-utensils" />
          &nbsp;{{ $t("shop.category") }}
        </span>
        <span
          class="button is-rounded is-link is-small"
          :class="{'is-outlined': sortedBy !== 'filter'}"
          @click="sortBy('filter')"
        >
          <i class="fa fa-filter" />
          &nbsp;{{ $t("shop.filter") }}
        </span>
        <span
          class="button is-rounded is-link is-small"
          :class="{'is-outlined': sortedBy !== 'distance'}"
          @click="sortBy('distance')"
        >
          <i class="fa fa-route" />
          &nbsp;{{ $t("shop.distance") }}
        </span>
        <span
          class="button is-rounded is-link is-small"
          :class="{'is-outlined': sortedBy !== 'favorite'}"
          @click="sortBy('favorite')"
        >
          <i class="fa fa-heart" />
          &nbsp;{{ $t("shop.favorite") }}
        </span>
        <span
          class="button is-rounded is-link is-small"
          :class="{'is-outlined': sortedBy !== 'new'}"
          @click="sortBy('new')"
        >
          <i class="fa fa-child" />
          &nbsp;{{ $t("shop.new") }}
        </span>
      </span>
    </div>

    <!-- <ShopList v-show="listView" />
    <ShopMap v-show="!listView" />-->
    <keep-alive>
      <ShopList v-if="listView" />
      <ShopMap v-else />
    </keep-alive>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import MainBackButton from "@/components/MainBackButton.vue";
import ShopList from "@/components/ShopList.vue";
import ShopMap from "@/components/ShopMap.vue";
import ShopLive from "@/components/ShopLive.vue";

export default {
  name: "Shop",
  components: {
    MainBackButton,
    ShopList,
    ShopMap,
    ShopLive,
  },
  data() {
    return {
      listView: true,
      selected: "shops",
      sortedBy: "alphabet", // default sort
      searching: false,
      z: 0,
      // search: null
    };
  },
  computed: {
    searchPlaceholder() {
      return this.$t("shop.search");
      // return `🔎` + this.$t("shop.search");
    },
    shopsOrServices() {
      return this.$store.state.shopsOrServices;
    },
    translateSelected() {
      return this.$t(`shop.${this.shopsOrServices}`);
    },
    showShopsButton() {
      if (!this.searching) return true;
      if (this.selected === "shops") return true;
      return false;
    },
    showServicesButton() {
      if (!this.searching) return true;
      if (this.selected === "services") return true;
      return false;
    },
  },
  activated() {
    var query = this.$route.query;
    if (query.tab) {
      this.select(query.tab);
      this.searching = true;
    }
    if (query.filter) {
      this.sortBy("filter");
    }

    this.selected = this.shopsOrServices;
    // getBusinesses API should take a location to only get nearby businesses
    // this.$store.dispatch("getBusinesses").catch(err => this.apiError(err));
  },
  methods: {
    toggleSearch() {
      this.z += 1;
      this.searching = !this.searching;
      if (this.searching) {
        this.$nextTick(() => this.$el.querySelector(".searchbox").focus());
      } else EventBus.$emit("SHOP_LIST_SEARCH"); // reset search
    },
    toggleView() {
      this.z += 1;
      this.listView = !this.listView;
      EventBus.$emit("TOGGLE_SHOP_MAP");
    },
    select(type) {
      this.selected = type;
      this.$store.commit("setShopsOrServices", type);
      EventBus.$emit("SHOP_LIST_CHANGE");
      EventBus.$emit("UPDATE_SHOP_MAP");
    },
    sortBy(type) {
      this.sortedBy = type;
      EventBus.$emit("SHOP_LIST_SORT", type);
    },
    search(e) {
      var text = e.target.value;
      EventBus.$emit("SHOP_LIST_SEARCH", text.toLowerCase());
    },
  },
};
</script>

<style scoped>
.shop {
  overflow: hidden;
  height: 100vh;
}
.navigation {
  padding-right: 10px;
  padding-top: 10px;
  width: calc(100vw - 56px);
}
.dark {
  background-color: #123;
  color: white;
}
/* .dark .card {
  background-color: rgb(0, 56, 113);
  color: white;
} */
.single-line {
  white-space: nowrap;
  overflow: auto;
  margin-bottom: -10px;
  display: inline-block;
}
.single-line::-webkit-scrollbar {
  display: none;
}
.icon:active {
  transform: rotate(340deg);
  -webkit-transform: rotate(340deg);
  -ms-transform: rotate(340deg);
}
.select {
  padding-right: 0;
}
.button {
  padding: 13px;
}
.side-btn {
  padding: 0 15px;
}
.middle-btn {
  padding: 0 12px;
}
.input {
  padding: 0 12px;
}
</style>
